import {
    useEditCartItem,
    useEditCartItemActions,
} from '@/features/pos/components/OrderFinalization/contexts/EditCartItemProvider'
import { useCartItemConfigurableProduct } from '@/features/pos/components/OrderFinalization/hooks/editing-cart-item-modal/useCartItemConfigurableProduct'
import { useConfirmProductConfiguration } from '@/features/pos/components/OrderFinalization/hooks/editing-cart-item-modal/useConfirmProductConfiguration'
import ProductConfigurationModal from '@/features/pos/components/ProductConfigurationModal'
import { usePortal } from '@/features/pos/components/ProductConfigurationModal/contexts/Portal'
import { useCloseOnPosModeChange } from '@/features/pos/hooks/useCloseOnPosModeChange'
import { useMemo } from 'react'

export const useEditingCartItemModal = (): void => {
    const editingCartItemIds = useEditCartItem()

    const product = useCartItemConfigurableProduct(
        editingCartItemIds?.cartItemId,
        editingCartItemIds?.productId
    )

    const { unset } = useEditCartItemActions()

    const handleConfirm = useConfirmProductConfiguration(editingCartItemIds?.cartItemId)

    const MemoizedProductConfigurationModal = useMemo(
        () => (
            <ProductConfigurationModal
                productName={product?.name}
                productVariants={product?.productVariants}
                defaultProductVariantId={product?.defaultProductVariantId}
                onConfirm={handleConfirm}
                onCancel={unset}
            />
        ),
        [product, handleConfirm, unset]
    )

    usePortal(!!editingCartItemIds, MemoizedProductConfigurationModal)

    useCloseOnPosModeChange(unset)
}
